window.prototype = this;
const bodyScrollLock = require('./bodyScrollLock');

var text;
window.openCity = function (evt, cityName) {
  var i, k, tabcontent, tablinks, price_values;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";

  let condition_price = evt.currentTarget.getAttribute("data-original-price");
  var storage_price = $('.device_mem.active').attr("data-original-price");
  var price = parseInt(condition_price) + parseInt(storage_price);
  document.getElementById("warranty_price").innerHTML = price;
  var cbarray = document.getElementsByName('included');
    for(var k = 0; k < cbarray.length; k++){
        cbarray[k].checked = false;
    }
}

window.device_memory = function(evt, mem) {
  var i, device_mem;

  device_mem = document.getElementsByClassName("device_mem");
  for (i = 0; i < device_mem.length; i++) {
    device_mem[i].className = device_mem[i].className.replace(" active", "");
  }
  // document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
  let selected_value = evt.currentTarget.getAttribute("data-original-price");
  var this_price;
  var tab_value = $('.tablinks.active').attr("data-original-price");
    this_price = $('.device_mem.active').attr("data-original-price");
    var price = parseInt(tab_value) + parseInt(this_price);
    if(document.getElementById("warranty_price")){
        document.getElementById("warranty_price").innerHTML = price;
    }
  var cbarray = document.getElementsByName('included');
    for(var k = 0; k < cbarray.length; k++){
        cbarray[k].checked = false;
    }
}



$(document).ready(function(){

  let condition_price = $('.tablinks.active').attr("data-original-price");
  var storage_price = $('.device_mem.active').attr("data-original-price");
  var price = parseInt(condition_price) + parseInt(storage_price);
  if(document.getElementById("warranty_price")){
        document.getElementById("warranty_price").innerHTML = price;
    }

  $("#device_u_bn li").click(function(){
      $("#device_u_bn li").removeClass("active");
      // $(".tab").addClass("active"); // instead of this do the below
      $(this).addClass("active");
      if($("#device_u_bn li.active label").text() == "Brand New"){
        $("#main_device_Condition").hide();
      }else {
        $("#main_device_Condition").show();
      }
      console.log($("#device_u_bn li.active label").text());
  });

  $(".brand_new_device").click(function(){

  });

  $('#whats_included input:checkbox').change(function(){
    let condition_price = $('.tablinks.active').attr("data-original-price");
    var storage_price = $('.device_mem.active').attr("data-original-price");
    var price = parseInt(condition_price) + parseInt(storage_price);
    var tab_value = price;
    tot=tab_value;
    $('#whats_included input:checkbox:checked').each(function(){
    tot=parseInt(tot) + parseInt(this.value);
    });
        //  tot+=parseInt($('#more').val());
    $('#warranty_price').text(tot);
    });

         $('#more').change(function(){
          $('#whats_included input:checkbox').trigger('change');
         });



});

window.onload = function() {
  var mobileDropdown = document.getElementById( 'mobileDropdown' );
  var mobNavSwitch = document.getElementById( 'mobNavSwitch' );
  var mobile_top_button = document.getElementById( 'mobile_top_button' );
};


function mobileNavClose() {
  if(window.mobNavSwitch){
    window.mobNavSwitch.checked = false;
    mobileNavDropdown( window.mobNavSwitch );
  }
}

function mobileNavDropdown( e ){
  if(e.checked){
    window.mobileDropdown.style.opacity = 1;
    window.mobileDropdown.style.height = 'auto';
    window.mobile_top_button.style.height = 0;
    window.mobile_top_button.style.opacity = 0;
    // $(window).resize(function() {
    //   if($( window ).width() < 1000) {
    //     window.mobile_top_button.style.display = "none";
    //   }
    // });
  } else {
    window.mobileDropdown.style.opacity = 0;
    window.mobileDropdown.style.height = 0;
    window.mobile_top_button.style.height = 'auto';
    window.mobile_top_button.style.opacity = 1;
    // $(window).resize(function() {
    //   if($( window ).width() < 1000) {
    //     window.mobile_top_button.style.display = "flex";
    //   }
    // });

  }

}

function viewportFix() {
  document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
  document.documentElement.style.setProperty('--vw', window.innerWidth * 0.01 + 'px');
}

// Event Listeners //

window.addEventListener(
  "resize", function() {

    viewportFix();

    if ( window.innerWidth >= 1000 ) {
      mobileNavClose();
    }
  }
);

window.addEventListener(
  'scroll', function() {
    viewportFix();
});

window.addEventListener(
  'load', function(){
    viewportFix();
});

window.addEventListener(
  'orientationchange', function() {
    viewportFix();
  }
);

function toggle(className, displayState){
  var elements = document.getElementsByClassName(className)

  for (var i = 0; i < elements.length; i++){
      elements[i].style.display = displayState;
  }
}

window.modelFilter = function (input){
  var devices = document.querySelectorAll('.models .device');
  var options = document.getElementsByName('model-filter');

  // hide all elements
  if (devices) {
    for (var i = 0; i < devices.length; i++) {
      devices[i].style.display = 'none';
    }
  }

  if (options) {
    // show selected filter elements
    for (var i = 0; i < options.length; i++) {
      if(options[i].checked){
        toggle(options[i].id, 'flex');
      }
    }

  }

}

// overlay & popup

var funnel_status = false;

function showFunnelMobileDrop(){
  document.getElementById("nav_switch").checked = false;

  funnelClose();
  mobileNav();
  showFunnel();
}

function openFunnelMobile(){
  mobileNavClose();
  showFunnel();
  navSwitch.checked = false;
}

//// Custom Code ///////////////////////////
// console.log("openSellFunnelMobile")

window.openSellFunnelMobile =  function(){
  mobileNavClose();
  sellFunnel();
//   navSwitch.checked = false;
}

function sellFunnel(){

  var targetElement = document.querySelector("[id=funnelModal]");
  bodyScrollLock.disableBodyScroll(targetElement);

  document.getElementsByClassName('overlay')[0].style.display = 'flex';
  document.getElementById('bookingModal').style.display = 'none';
  document.getElementById('buyModal').style.display = 'none';

	const nodeList = document.querySelectorAll('.sell_span');
	for (let i = 0; i < nodeList.length; i++) {
	  nodeList[i].innerHTML = 'Sell'
	}

	document.querySelectorAll('[name="funnel-manufacturer"]')[0].setAttribute('data-mode', 'sell');

  document.getElementById('funnelModal').style.display = 'flex';


  var lastPage = document.getElementsByClassName(funnel_pages[funnel_pages.length - 1])[0];

  if(lastPage){
    lastPage.style.display = 'none';
    lastPage.id = '';
  }

  // show manufacturers page
  document.getElementsByClassName('funnel-manufacturers')[0].style.display = 'flex';
  document.getElementsByClassName('funnel-manufacturers')[0].id = 'funnelCurrentView';

  funnel_status = true;

}

// console.log("openBuyFunnelMobile")

window.openBuyFunnelMobile = function (){
  mobileNavClose();
  buyFunnel();
//   navSwitch.checked = false;
}

// function buyFunnel(){

//   var targetElement = document.querySelector("[id=funnelModal]");
//   bodyScrollLock.disableBodyScroll(targetElement);

//   document.getElementsByClassName('overlay')[0].style.display = 'none';
//   document.getElementById('bookingModal').style.display = 'none';
//   document.getElementById('buyModal').style.display = 'flex';
// // 	document.querySelectorAll('.sell_span').innerHTML = 'Buy'

// 	const nodeList = document.querySelectorAll('.sell_span');
// 	for (let i = 0; i < nodeList.length; i++) {
// 	  nodeList[i].innerHTML = 'Buy'
// 	}

// 	document.querySelectorAll('[name="funnel-manufacturer"]')[0].setAttribute('data-mode', 'buy');

//   document.getElementById('funnelModal').style.display = 'flex';

//   var lastPage = document.getElementsByClassName(funnel_pages[funnel_pages.length - 1])[0];

//   if(lastPage){
//     lastPage.style.display = 'none';
//     lastPage.id = '';
//   }

//   // show manufacturers page
//   document.getElementsByClassName('funnel-manufacturers')[0].style.display = 'flex';
//   document.getElementsByClassName('funnel-manufacturers')[0].id = 'funnelCurrentView';

//   funnel_status = true;

// }

function buyFunnel(){

  var targetElement = document.querySelector("[id=buyModal]");
  bodyScrollLock.disableBodyScroll(targetElement);

  document.getElementsByClassName('overlay')[0].style.display = 'flex';
  document.getElementById('bookingModal').style.display = 'none';
  document.getElementById('buyModal').style.display = 'flex';
  document.getElementById('funnelModal').style.display = 'none';


  var lastPage = document.getElementsByClassName(funnel_pages[funnel_pages.length - 1])[0];

  if(lastPage){
    lastPage.style.display = 'none';
    lastPage.id = '';
  }

  // show manufacturers page
  document.getElementsByClassName('funnel-manufacturers')[0].style.display = 'flex';
  document.getElementsByClassName('funnel-manufacturers')[0].id = 'buyfunnelCurrentView';

  funnel_status = true;

}

//// Custom Code ///////////////////////////

function showFunnel(){

  var targetElement = document.querySelector("[id=funnelModal]");
  bodyScrollLock.disableBodyScroll(targetElement);

  document.getElementsByClassName('overlay')[0].style.display = 'flex';
  document.getElementById('bookingModal').style.display = 'none';
  document.getElementById('funnelModal').style.display = 'flex';


  var lastPage = document.getElementsByClassName(funnel_pages[funnel_pages.length - 1])[0];

  if(lastPage){
    lastPage.style.display = 'none';
    lastPage.id = '';
  }

  // show manufacturers page
  document.getElementsByClassName('funnel-manufacturers')[0].style.display = 'flex';
  document.getElementsByClassName('funnel-manufacturers')[0].id = 'funnelCurrentView';

  funnel_status = true;

}

function sellModal(){

  var targetElement = document.querySelector("[id=sellModal]");
  bodyScrollLock.disableBodyScroll(targetElement);

  document.getElementsByClassName('overlay')[0].style.display = 'flex';
  document.getElementById('bookingModal').style.display = 'none';
  document.getElementById('sellModal').style.display = 'flex';


  var lastPage = document.getElementsByClassName(funnel_pages[funnel_pages.length - 1])[0];

  if(lastPage){
    lastPage.style.display = 'none';
    lastPage.id = '';
  }

  // show manufacturers page
  document.getElementsByClassName('funnel-manufacturers')[0].style.display = 'flex';
  document.getElementsByClassName('funnel-manufacturers')[0].id = 'funnelCurrentView';

  funnel_status = true;

}

// funnel

var funnel_progress = [0];
var funnel_pages = [];

function funnelProgress(page_id){

  // Test for Exisiting Funnel Page
  var page_exists = funnel_pages.includes(page_id.value);

	let text = page_id.id;
	let result = text.includes("repairs");
	console.log(result,page_id);
	if(result){
		funnelOut(page_id);
		window.location.href = page_id.getAttribute('data-permalink');
	}else{

  // Navigation Operations ========== //
  // || get the progress bar elements via querySelectorAll
  navigation_progress_bars = document.querySelectorAll('.funnelNavItem');
  navigation_progress_bars[funnel_progress.length - 1].className = "complete funnelNavItem";
  $funnel_elements = document.querySelectorAll('[id=theFunnel]');

  // View-Based Operations ========== //
  // || add selected object to the funnel_progress aray
  funnel_progress.push(page_id.value);
  funnel_pages.push(page_id.value);
  // || get the current view element being shown
  var funnel_current = document.getElementById('funnelCurrentView');
  // || hide the current view
  funnel_current.style.display = 'none';
  // || remove current view id as no longer being shown
  funnel_current.removeAttribute("id");
  // || display the loading screen
  document.getElementById('funnelLoading').style.display = 'flex';

  if(funnel_status){

    if(page_exists){
      var page_id_value = page_id.value.toString();
      var the_page = document.getElementsByClassName(page_id_value)[0];

      document.getElementById('funnelLoading').style.display = 'none';
      the_page.style.display = 'flex';
      the_page.id = 'funnelCurrentView';
    } else {

      // XMLHttpRequest // funnel_ajax
      // Gets from WP Admin AJAX
      var request = new XMLHttpRequest();

      request.open('POST', screenfixed.admin_ajax, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

      request.onload = function () {
          if (this.status >= 200 && this.status < 400) {

            document.getElementById('funnelLoading').style.display = 'none';
            var result = request.responseText;
          // 			  console.log(result);
            document.getElementById('funnelBottom').insertAdjacentHTML("beforebegin", result);

          } else {
              console.log('Response error');
          }
        };
        request.onerror = function() {
          console.log('Connection error');
        };

        request.send('action=funnel_ajax&id=' + page_id.value + '&pages=' + funnel_progress.length);

    }

  }
	}

}

var buy_funnel_progress = [0];
var buy_funnel_pages = [];
function buyfunnelProgress(page_id){

  // Test for Exisiting Funnel Page
  var page_exists = buy_funnel_pages.includes(page_id.value);

    let text = page_id.id;
    let result = text.includes("buy");
    console.log(result,page_id);
    if(result){
        funnelOut(page_id);
        window.location.href = page_id.getAttribute('data-permalink');
    }else{

  // Navigation Operations ========== //
  // || get the progress bar elements via querySelectorAll
  navigation_progress_bars = document.querySelectorAll('.funnelNavItem');
  navigation_progress_bars[buy_funnel_progress.length - 1].className = "complete funnelNavItem";
  $funnel_elements = document.querySelectorAll('[id=theBuyFunnel]');

  // View-Based Operations ========== //
  // || add selected object to the funnel_progress aray
  buy_funnel_progress.push(page_id.value);
  buy_funnel_pages.push(page_id.value);
  // || get the current view element being shown
  var funnel_current = document.querySelectorAll('.buy-funnel-manufacturers')[0];
  // || hide the current view
  funnel_current.style.display = 'none';
  // || remove current view id as no longer being shown
  funnel_current.removeAttribute("id");
  // || display the loading screen
  document.querySelectorAll('buy-funnel-loading')[0].style.display = 'flex';

  if(funnel_status){

    if(page_exists){
      var page_id_value = page_id.value.toString();
      var the_page = document.getElementsByClassName(page_id_value)[0];

      document.querySelectorAll('buy-funnel-loading')[0].style.display = 'none';
      the_page.style.display = 'flex';
      the_page.id = 'funnelCurrentView';
    } else {

		console.log(page_id_value,the_page);

      // XMLHttpRequest // funnel_ajax
      // Gets from WP Admin AJAX
      var request = new XMLHttpRequest();

      request.open('POST', screenfixed.admin_ajax, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

      request.onload = function () {
          if (this.status >= 200 && this.status < 400) {

            document.querySelectorAll('buy-funnel-loading')[0].style.display = 'none';
            var result = request.responseText;
// 			  console.log(result);
            document.querySelectorAll('buy-funnel-bottom')[0].insertAdjacentHTML("beforebegin", result);

          } else {
              console.log('Response error');
          }
        };
        request.onerror = function() {
          console.log('Connection error');
        };

        request.send('action=funnel_ajax&id=' + page_id.value + '&pages=' + buy_funnel_progress.length);

    }

  }
    }

}

function funnelOut(){

  navigation_progress_bars = document.querySelectorAll('.funnelNavItem');
//   navigation_progress_bars[funnel_progress.length - 1].className = "complete funnelNavItem";
  $funnel_elements = document.querySelectorAll('[id=theFunnel]');

  // || get the current view element being shown
  var funnel_current = document.getElementById('funnelCurrentView');
  // || hide the current view
  funnel_current.style.display = 'none';
  // || remove current view id as no longer being shown
  funnel_current.removeAttribute("id");
  // || display the loading screen
  document.getElementById('funnelLoading').style.display = 'flex';
}

window.funnelBack = function(){

    // hide current
    document.getElementsByClassName(funnel_progress[funnel_progress.length - 1])[0].style.display = 'none';
    document.getElementsByClassName(funnel_progress[funnel_progress.length - 1])[0].id = '';

    // remove from progress array
    funnel_progress.pop();

    // show previous
    var previous_page = document.getElementsByClassName(funnel_progress[funnel_progress.length - 1])[0];
    previous_page.id = 'funnelCurrentView';
    document.getElementsByClassName(funnel_progress[funnel_progress.length - 1])[0].style.display = 'flex';

    // update indicator
    document.getElementsByClassName('funnelNavItem')[funnel_progress.length - 1].className = "funnelNavItem";
}

window.funnelClose = function (){

  funnel_status = false;

  // get current and hide
  var funnel_current = document.getElementById('funnelCurrentView');

  if(funnel_current){
    funnel_current.style.display = 'none';
    funnel_current.removeAttribute("id");
  }
  // return body scroll once closes
  bodyScrollLock.clearAllBodyScrollLocks();
  document.getElementsByClassName('overlay')[0].style.display = 'none';

  // show manufacturers page
  document.getElementsByClassName('funnel-manufacturers')[0].style.display = 'flex';
  document.getElementsByClassName('funnel-manufacturers')[0].id = 'funnelCurrentView';

  // fix nav indicators
  var elems = document.getElementsByClassName('complete funnelNavItem');

  while (elems[0]) {
    elems[0].classList.remove('complete');
  }

  // reset funnel_progress array
  funnel_progress = [0];

}

window.closeBooking = function (){

    // return body scroll once closes
  bodyScrollLock.clearAllBodyScrollLocks();
  document.getElementsByClassName('overlay')[0].style.display = 'none';
}

function showAllRepairs(e){
  var all_repairs = document.getElementById('allRepairsList');
  var checked_status = e.checked;

  if(checked_status){
    all_repairs.style.display = 'flex';
  } else {
    all_repairs.style.display = 'none';
  }

}

// repair page

function togglePrice(e){

  var selectedPrice = e.id;
  var premiumPrice = document.getElementById('premiumPrice');
  var aftermarketPrice = document.getElementById('aftermarketPrice');

  switch(selectedPrice){
    case 'premium':
      premiumPrice.style.display = 'flex';
      aftermarketPrice.style.display = 'none';
      break;
    case 'aftermarket':
      aftermarketPrice.style.display = 'flex';
      premiumPrice.style.display = 'none';
      break;
  }

  showVariationInfo();

}

function showVariationInfo(){

  var qualityVariations = document.getElementsByName('part_type');

  var premiumInfoText = document.getElementById('premiumInfoText');
  var aftermarketInfoText = document.getElementById('aftermarketInfoText');


  for (var i = 0, length = qualityVariations.length; i < length; i++){
    if (qualityVariations[i].checked){
      var selected = qualityVariations[i].id;
      break;
    }
  }

  switch(selected){
    case 'premium':
      premiumInfoText.style.display = 'flex';
      aftermarketInfoText.style.display = 'none';
      break;
    case 'aftermarket':
      aftermarketInfoText.style.display = 'flex';
      premiumInfoText.style.display = 'none';
      break;
  }

}

/// booking

var booking_progress = {
  'repair': '',
  'part_type': '',
  'city': '',
  'name': '',
  'email': '',
  'phone': '',
};

window.bookingProgress = function (e) {

  var partType = document.getElementsByName('partType');
  var city = document.getElementsByName('locationControl');
  var payment = document.getElementsByName('payment');

  if (e == 'part_type'){

    if (partType) {
      for (var i = 0; i < partType.length; i++) {
        if(partType[i].checked){
          booking_progress.part_type = partType[i].value;
        }
      }
    }

    document.getElementById('partTypeCard').style.display = 'none';
    document.getElementById('paymentCard').style.display = 'none';
    document.getElementById('cityCard').style.display = 'flex';


  } else if (e == 'city'){


    if (city) {
      for (var i = 0; i < city.length; i++) {
        if(city[i].checked){
          booking_progress.city = city[i].value;
        }
      }
    }

    document.getElementById('cityCard').style.display = 'none';
    document.getElementById('paymentCard').style.display = 'none';
    document.getElementById('infoCard').style.display = 'flex';

    document.getElementById("bookingName").focus;

  }else if (e == 'payment'){


    if (payment) {
      for (var i = 0; i < payment.length; i++) {
        if(payment[i].checked){
          booking_progress.payment = payment[i].value;
        }
      }
    }

    document.getElementById('cityCard').style.display = 'none';
    document.getElementById('infoCard').style.display = 'none';
    document.getElementById('paymentCard').style.display = 'flex';

    document.getElementById("bookingName").focus;

  } else if (e == 'bookingInfo') {

    var iemi = document.getElementById('bookingDevice_IMEI');
    var name = document.getElementById('bookingName');
    var email = document.getElementById('bookingEmail');
    var phone = document.getElementById('bookingPhone');

    booking_progress.iemi = iemi.value;
    booking_progress.name = name.value;
    booking_progress.email = email.value;
    booking_progress.phone = phone.value;
    if (iemi.value.length == 0 || name.value.length == 0 || email.value.length == 0 || phone.value.length == 0){
      iemi.style.borderColor = 'red';
      name.style.borderColor = 'red';
      email.style.borderColor = 'red';
      phone.style.borderColor = 'red';
      return;
    }

    var nameDisplay = document.getElementById('bookingNameConfirm');

    nameDisplay.textContent = ', ' + name.value.charAt(0).toUpperCase() + name.value.slice(1).split(" ")[0] + '!';

    document.getElementById('infoCard').style.display = 'none';
    document.getElementById('confirmationCard').style.display = 'flex';

    submitBooking(booking_progress);

  }
}

window.bookingPrevious = function() {
  console.log('previous');

  if (booking_progress.city.length != 0){
    document.getElementById('infoCard').style.display = 'none';
    document.getElementById('cityCard').style.display = 'flex';
    booking_progress.city = '';
  } else if (booking_progress.part_type.length !=0) {
    document.getElementById('cityCard').style.display = 'none';
    document.getElementById('partTypeCard').style.display = 'flex';
    booking_progress.city = '';

  }
}

window.showBooking = function (e, repair){

  booking_progress.repair = repair;

  var targetElement = document.querySelector("[id=bookingModal]");
  bodyScrollLock.disableBodyScroll(targetElement);

  document.getElementsByClassName('overlay')[0].style.display = 'flex';
  document.getElementById('funnelModal').style.display = 'none';
  document.getElementById('bookingModal').style.display = 'flex';

  if(e != 'null'){
    booking_progress.part_type = e;

    document.getElementById('bookingPartType').textContent = e.charAt(0).toUpperCase() + e.slice(1);
  } else {
    document.getElementById('bookingPartType').textContent = 'aftermarket';
  }

}

// Start Sell Form
window.showSellPhoneModel = function (){

  var targetElement = document.querySelector("[id=showSellPhoneModel]");
  bodyScrollLock.disableBodyScroll(targetElement);
  var curr_price = $('#net_price').text();
  $('.final_price').text(curr_price);
  // // $('.final_price').html() = $('#warranty_price').text();
  // console.log($('.final_price').text(curr_price));
  // console.log($('#warranty_price').text());
  document.getElementsByClassName('overlay')[0].style.display = 'flex';
  document.getElementById('funnelModal').style.display = 'none';
  document.getElementById('bookingModal').style.display = 'none';
  document.getElementById('showSellPhoneModel').style.display = 'block';

}

function defer(method) {
    if (window.$) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}

//jQuery time
var current_fs, next_fs, previous_fs; //fieldsets
var left, opacity, scale; //fieldset properties which we will animate
var animating; //flag to prevent quick multi-click glitches
// window.onload = function() {
//
defer(function () {
$(".next").click(function(){
	if(animating) return false;
	animating = true;

	current_fs = $(this).parent();
	next_fs = $(this).parent().next();

	//activate next step on progressbar using the index of next_fs
	$("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

	//show the next fieldset
	next_fs.show();
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			//as the opacity of current_fs reduces to 0 - stored in "now"
			//1. scale current_fs down to 80%
			scale = 1 - (1 - now) * 0.2;
			//2. bring next_fs from the right(50%)
			left = (now * 50)+"%";
			//3. increase opacity of next_fs to 1 as it moves in
			opacity = 1 - now;
			current_fs.css({
        'transform': 'scale('+scale+')',
        'position': 'absolute'
      });
			next_fs.css({'left': left, 'opacity': opacity});
		},
		duration: 800,
		complete: function(){
			current_fs.hide();
			animating = false;
		},
		//this comes from the custom easing plugin
		easing: 'easeInOutBack'
	});
});

$(".previous").click(function(){
	if(animating) return false;
	animating = true;

	current_fs = $(this).parent();
	previous_fs = $(this).parent().prev();

	//de-activate current step on progressbar
	$("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

	//show the previous fieldset
	previous_fs.show();
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			//as the opacity of current_fs reduces to 0 - stored in "now"
			//1. scale previous_fs from 80% to 100%
			scale = 0.8 + (1 - now) * 0.2;
			//2. take current_fs to the right(50%) - from 0%
			left = ((1-now) * 50)+"%";
			//3. increase opacity of previous_fs to 1 as it moves in
			opacity = 1 - now;
			current_fs.css({'left': left});
			previous_fs.css({'transform': 'scale('+scale+')', 'opacity': opacity});
		},
		duration: 800,
		complete: function(){
			current_fs.hide();
			animating = false;
		},
		//this comes from the custom easing plugin
		easing: 'easeInOutBack'
	});
});

$(".submit").click(function(){
	return false;
})
	 });
// }
// End Sell Form

window.updateBookingPrice = function (e) {

  var aftermarketDesc = document.getElementById('aftermarketDesc');
  var premiumDesc = document.getElementById('premiumDesc');

  var aftermarketPrice = document.getElementById('aftermarketPrice');
  var premiumPrice = document.getElementById('premiumPrice');

  var bookingPartType = document.getElementById('bookingPartType');

  if(e == 'aftermarketPart'){
    premiumPrice.style.display = 'none';
    premiumDesc.style.display = 'none';
    aftermarketPrice.style.display = 'block';
    aftermarketDesc.style.display = 'block';

    bookingPartType.textContent = 'aftermatket';

  } else if (e == 'premiumPart') {
    aftermarketPrice.style.display = 'none';
    aftermarketDesc.style.display = 'none';
    premiumPrice.style.display = 'block';
    premiumDesc.style.display = 'block';

    bookingPartType.textContent = 'premium' ;

  }
}

window.validateButton = function (e){

  if (e == 'cityButton'){

    document.getElementsByClassName('cityAddressInfo')[0].style.display = 'flex';
    var city = document.getElementsByName('locationControl');
    // var city = document.getElementsByName('locationControl');
    console.log(city);

    if (city) {
      // for (var i = 0; i < city.length; i++) {
      //   if(city[i].checked){
      //     document.getElementById(city[i].value + 'Address').style.display = 'flex';
      //   } else {
      //     document.getElementById(city[i].value + 'Address').style.display = 'none';
      //   }
      // }
      document.getElementById(e).disabled = false;
    }
    // document.getElementById(e).disabled = false;
  } else if (e == 'paymentButton'){

    document.getElementsByClassName('cityAddressInfo')[0].style.display = 'flex';
    var payment = document.getElementsByName('payment');

    if (payment) {
      document.getElementById(e).disabled = false;
    }
  }
  document.getElementById(e).disabled = false;
}

function disableButton(e){
  document.getElementById(e).disabled = true;
}

window.validateUserInput = function(){
  var iemi = document.getElementById('bookingDevice_IMEI');
  var name = document.getElementById('bookingName');
  var email = document.getElementById('bookingEmail');
  var phone = document.getElementById('bookingPhone');

  if (iemi.value.length != 0  && name.value.length != 0  && email.value.length != 0 && phone.value.length != 0) {
    validateButton('userInfoButton')
  } else {
    disableButton('userInfoButton');
  }
}

window.submitBooking = function(e){
  var repair = encodeURIComponent(e.repair);
  var part_type = encodeURIComponent(e.part_type);
  var city = encodeURIComponent(e.city);
  var name = encodeURIComponent(e.name);
  var phone = encodeURIComponent(e.phone);
  var email = encodeURIComponent(e.email);

  var nonceData = document.getElementById('userInfoButton').getAttribute('data-nonce');
  var term_id = document.getElementById('userInfoButton').getAttribute('data-id');

  var request = new XMLHttpRequest();

  request.open('POST', screenfixed.admin_ajax, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

  request.onload = function () {

      if (this.status >= 200 && this.status < 400) {

        // booking worked
        console.log('booking worked');

      } else {

        // booking failed
        console.log('booking failed');

      }

    };

  var request1 = new XMLHttpRequest();
  request1.open('POST', 'https://hooks.zapier.com/hooks/catch/708641/bhawpgi/', true);
  request1.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request1.onload = function () {

      if (this.status >= 200 && this.status < 400) {

        // booking worked
        console.log('booking worked');

      } else {

        // booking failed
        console.log('booking failed');

      }

    };


    request.onerror = function() {
      console.log('Connection error');
    };

	request1.onerror = function() {
      console.log('Connection error');
    };

    var data = "";

    data += 'action=' + 'booking_ajax';
    data += '&nonce=' + nonceData;
    data += '&repair=' + repair;
    data += '&part_type=' + part_type;
    data += '&city=' + city;
    data += '&name=' + name;
    data += '&email=' + email;
    data += '&phone=' + phone;
    data += '&term_id=' + term_id;

    console.log(data);

    request.send(data);

	var data1 = "";

    data1 += 'action=' + 'booking_ajax';
    data1 += '&nonce=' + nonceData;
    data1 += '&funnel=' + repair;
    data1 += '&part_type=' + part_type;
    data1 += '&city=' + city;
    data1 += '&name=' + name;
    data1 += '&email=' + email;
    data1 += '&phone=' + phone;
    data1 += '&term_id=' + term_id;

    console.log(data1);

    request1.send(data1);

}

// price list filter


window.priceListFilter = function (e){

  var devices = document.querySelectorAll('.modelsList .model');
  var options = document.getElementsByName('modelListFilter');

  // hide all elements
  if (devices) {
    for (var i = 0; i < devices.length; i++) {
      devices[i].style.display = 'none';
    }
  }

  if (options) {
    // show selected filter elements
    for (var i = 0; i < options.length; i++) {
      if(options[i].checked){
        toggle(options[i].id, 'block');
      }
    }
  }

  if(!devices || !options) {
    console.log('error: devices and/or options not found!');
  }
}

// price list page

function showAllModels() {

  var options = document.querySelectorAll('.sortBox .option');

  if(options) {
    for ( var i = 0; i < options.length; i++) {
      options[i].style.display = 'flex';
    }
  }

  document.querySelectorAll('.sortBox .more')[0].style.display = 'none';

}


// Reviews Block

function cityReviewListFilter(e){

  var reviews = document.querySelectorAll('.reviews .review');
  var options = document.getElementsByName('cityReviewFilter');

  // hide all elements
  if (reviews) {
    for (var i = 0; i < reviews.length; i++) {
      reviews[i].style.display = 'none';
    }
  }

  if (options) {
    // show selected filter elements
    for (var i = 0; i < options.length; i++) {
      if(options[i].checked){
        toggle(options[i].id, 'flex');
      }
    }
    console.log(options);
  }
}

function initMap(id, lat, lng, text) {
            var coordinates = {
                lat: lat,
                lng: lng
            };
            var map = new google.maps.Map(document.getElementById(id), {
                zoom: 16,
                center: coordinates,
                scrollwheel: false
            });
            var measle = new google.maps.Marker({
                position: coordinates,
                map: map,
                icon: {
                    url: "https://maps.gstatic.com/intl/en_us/mapfiles/markers2/measle.png",
                    size: new google.maps.Size(7, 7),
                    anchor: new google.maps.Point(4, 4)
                }
            });
            var marker = new google.maps.Marker({
                position: coordinates,
                map: map,
                icon: {
                    url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                    labelOrigin: new google.maps.Point(75, 32),
                    size: new google.maps.Size(32, 32),
                    anchor: new google.maps.Point(16, 32)
                },
                label: {
                    text: text,
                    color: "#C70E20",
                    fontWeight: "bold"
                }
            });
        }

try{
    initMap('melbourne-map', -37.81637886097845, 144.9654847773137, 'Screen Fixed Melbourne')
initMap('brisbane-map', -27.4659831, 153.0289462, 'Screen Fixed Brisbane')
initMap('sydney-map', -33.87217334341136, 151.2091825938698, 'Screen Fixed Sydney')
}catch(e){

}
